/**
 * @generated SignedSource<<f5bf35fd9a8775047a253ebd596010fd>>
 * @relayHash 15e97c76ff1afad0c6f4513c9b67515a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6986cfeaaad1f684c07e3beec3cde7deb2f043d76e03022d75e60c89d85350f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameOrDescriptionFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
};
export type FieldSchemePageQuery$data = {
  readonly fieldSchemeNode: {
    readonly " $fragmentSpreads": FragmentRefs<"PageHeader">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "fieldSchemeAri"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PageHeader"
              }
            ],
            "type": "JiraFieldScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  (v6/*: any*/),
                  {
                    "concreteType": "JiraIssueFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldSchemeOperations",
                        "kind": "LinkedField",
                        "name": "fieldSchemeOperations",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canRemove"
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectsCount"
              }
            ],
            "type": "JiraFieldScheme"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "b6986cfeaaad1f684c07e3beec3cde7deb2f043d76e03022d75e60c89d85350f",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "55b354f596abefb5b02d36da69318c8b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
